import { render, staticRenderFns } from "./riskdrawertwo.vue?vue&type=template&id=2bf0bf39&scoped=true&"
import script from "./riskdrawertwo.vue?vue&type=script&lang=js&"
export * from "./riskdrawertwo.vue?vue&type=script&lang=js&"
import style0 from "./riskdrawertwo.vue?vue&type=style&index=0&id=2bf0bf39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0bf39",
  null
  
)

export default component.exports